import Vue from 'vue'
import Vuex from 'vuex'
// tag 标签页
import tagsView from './modules/tagsView'
// 用户信息
import user from './modules/user'
// 表格分页
import tablePage from './modules/tablePage'
// 招生报名
import enrollmentManagement from './modules/enrollAndRecruit/enrollmentManagement'
// 国家城市选择
import cityPicker from './modules/cityPicker'
// 学生请假
import studentLeave from './modules/notificationManagement/studentLeaveList'
// 课程管理
import courseManagement from './modules/courseManagement/courseManagement'
// 消息中心
import messageCenter from './modules/messageCenter'
// 共享文档（qa）- 文件管理
import fileManagement from './modules/qa/fileManagement'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    tagsView,
    user,
    tablePage,
    enrollmentManagement,
    cityPicker,
    studentLeave,
    messageCenter,
    courseManagement,
    fileManagement
  },
  getters: {
    // tag标签页
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,

    // 用户信息
    token: state => state.user.token,

    //清除tags标签
    clearTags:( state =>{
      state.tagsView.visitedViews =[];
      return state.tagsView.visitedViews;
    })
  },
  mutations: {
    CLEAR_TAGS: (state) =>{  //清空tags
      state.tagsView.visitedViews = []
    },
  },

  actions: {
   //清空tags标签
    clear_tags({commit}) {
      commit('CLEAR_TAGS')
    },
    
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js